import { loc } from "../i18n/survey";

enum MuscleFocus {
  Chest = 'Chest',
  Back = 'Back',
  Arms = 'Arms',
  Shoulders = 'Shoulders',
  Legs = 'Legs',
  Glutes = 'Glutes',
  Calves = 'Calves',
  Equally = 'Equally',
}
const muscleFocusQuestion = {
  name: "muscleFocus",
  title: loc("quiz.muscleFocus.title"),
  description: loc("quiz.muscleFocus.description"),
  descriptionLocation: "underTitle",
  type: "radiogroup",
  choices: [
    {
      value: MuscleFocus.Chest,
      text: loc("quiz.muscleFocus.choices.chest"),
    },
    {
      value: MuscleFocus.Back,
      text: loc("quiz.muscleFocus.choices.back"),
    },
    {
      value: MuscleFocus.Arms,
      text: loc("quiz.muscleFocus.choices.arms"),
    },
    {
      value: MuscleFocus.Shoulders,
      text: loc("quiz.muscleFocus.choices.shoulders"),
    },
    {
      value: MuscleFocus.Legs,
      text: loc("quiz.muscleFocus.choices.legs"),
    },
    {
      value: MuscleFocus.Glutes,
      text: loc("quiz.muscleFocus.choices.glutes"),
    },
    {
      value: MuscleFocus.Calves,
      text: loc("quiz.muscleFocus.choices.calves"),
    },
    {
      value: MuscleFocus.Equally,
      text: loc("quiz.muscleFocus.choices.equally"),
    },
  ],
  isRequired: true,
};

export { MuscleFocus, muscleFocusQuestion };
